import { camelCase, snakeCase } from 'scule'
import type { LocationData, LocationApiResponse } from '../types'

/**
 * Converts an object from camelCase to snake_case format
 * @param data - Object with camelCase keys
 * @returns Object with snake_case keys
 */
export function convertToSnakeCase<T extends Record<string, unknown>>(data: T): Record<string, unknown> {
  const result: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined && value !== null) {
      const snakeKey = snakeCase(key)
      result[snakeKey] = value
    }
  }

  return result
}

/**
 * Converts an object from snake_case to camelCase format
 * @param data - Object with snake_case keys
 * @returns Object with camelCase keys
 */
export function convertToCamelCase<T extends Record<string, unknown>>(data: T): Record<string, unknown> {
  const result: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined && value !== null) {
      const camelKey = camelCase(key)
      result[camelKey] = value
    }
  }

  return result
}

/**
 * Converts location data from camelCase to snake_case format
 * @param location - Location data in camelCase
 * @returns Location data in snake_case
 */
export function convertLocationToSnakeCase(location: Partial<LocationData>): Partial<LocationApiResponse> {
  return convertToSnakeCase(location) as Partial<LocationApiResponse>
}

/**
 * Converts location data from snake_case to camelCase format
 * @param location - Location data in snake_case
 * @returns Location data in camelCase
 */
export function convertLocationToCamelCase(location: Partial<LocationApiResponse>): Partial<LocationData> {
  return convertToCamelCase(location) as Partial<LocationData>
}
